import styled from 'styled-components'
import { t } from 'ttag'

import { SY80T, SY80S } from '@h2/components/colors'
import { Skeleton } from '@h2/components/loading/skeleton'

import { FeedItem } from './item'

const ErrorMsg = styled.div`
  background-color: ${SY80T};
  text-align: center;
  color: ${SY80S};
  border-radius: 4px;
  padding: 10px;
`
const FeedList = ({ items = [], isFetching = false, defaultHeight = '400px' }) => {
  if (isFetching) {
    return <Skeleton display="block" height={defaultHeight} />
  }

  if (!items.length) {
    return <ErrorMsg>{t`Feed is empty`}</ErrorMsg>
  }

  return items.map((item, index) => <FeedItem item={item} key={index} />)
}

export { FeedList }
